
import React from "react";
import { i18nManager } from "../../../i18n";
import * as ReactRouterDom from "react-router-dom";
import { CacheManager, Debugger, Schemes, Utils } from "../../../utils";
import { ApiResponseData, IPlatform, IProfile, ISupportCategory, SanitizedResponse, SupportCategoryService, SupportRequestService } from "../../../services";
import { AlertInterface, Alignment, Button, ButtonManageRef, Classname, Dropdown, FormControl, FormGroup, MessageSchemesIcons, Scheme, TextAreaInput, Transition, loadingAlert } from "@ronuse/noseur";

export type CreateProps = {
    setTitle: (title: string) => void;
};

function Create(props: CreateProps) {
    const navigate = ReactRouterDom.useNavigate();
    const { platform } = ReactRouterDom.useParams();
    const labels = i18nManager.Labels.support.ticket.create;
    const [message, setMessage] = React.useState<string>("");
    const activePlatform = CacheManager.getPlatform(platform);
    const submitButtonManageRef = React.useRef<ButtonManageRef>(null);
    const supportRequestService = SupportRequestService.getInstance();
    const supportCategoryService = SupportCategoryService.getInstance();
    const profile = CacheManager.get(CacheManager.PROFILE_KEY) as IProfile;
    const [selectedCategoryId, setSelectedCategoryId] = React.useState<string>("");
    const [supportCategories, setSupportCategories] = React.useState<ApiResponseData<ISupportCategory>>({});

    console.log("HGHGHG", activePlatform);
    React.useEffect(() => {
        if (!activePlatform) return;
        props.setTitle(labels.submit_a_ticket);
        supportCategoryService.querySupportCategories({ "platform.external_id": activePlatform?.external_id, size: 100 }).then(({ apiResponse }: SanitizedResponse<any>) => {
            Debugger.log("Create:useEffect:querySupportCategories", apiResponse.data);
            setSupportCategories(apiResponse.data!);
        }).catch((error: SanitizedResponse<any>) => {
            Utils.reportError(error);
        });
    }, []);

    return (<div className="create-ticket">
        <span>{labels.desc}</span>
        <FormGroup scheme={Schemes.RIVTN_HERA} style={{ maxWidth: 900 }}>
            <span className="title">{labels.submit_a_request}</span>
            <FormControl label={labels.select_category} fill>
                <Dropdown className="create-ticket-input" options={supportCategories.content} optionMap={{ label: "{name}", value: "{external_id}" }}
                    onSelectOption={(c: ISupportCategory) => {
                        setSelectedCategoryId(c.external_id);
                        return true;
                    }} fill />
            </FormControl>
            <FormControl label={labels.message} fill>
                <TextAreaInput className="create-ticket-textarea" onInputComplete={setMessage} fill />
            </FormControl>
            <Button manageRef={submitButtonManageRef} text={labels.submit} loadingProps={Utils.BUTTON_LOADING_PROPS} onClick={submitRequest} raised />
        </FormGroup>
    </div>);

    async function submitRequest() {
        if (!selectedCategoryId || !message) {
            Utils.report(labels.category_and_message_required, Scheme.WARNING, MessageSchemesIcons.WARNING);
            return;
        }
        let ticketId: string;
        const payload = {
            message,
            category_id: selectedCategoryId,
            platform_id: activePlatform?.platform_id,
            user: {
                last_name: profile.last_name,
                first_name: profile.first_name,
                middle_name: profile.other_names,
                profile_picture_location: profile.profile_picture_location
            }
        };
        submitButtonManageRef.current?.setLoadingState(true);
        const alert = loadingAlert({
            cancel: null,
            alignFooter: Alignment.CENTER,
            message: (<div className="request-success">
                <i className={Classname.build("fa fa-star", Transition.ZOOM_IN)} />
                <span className="title">{labels.thank_you}</span>
                <span>{labels.submission_received}</span>
                <span>{labels.will_be_in_touch}</span>
            </div>),
            confirm: {
                scheme: Schemes.RIVTN_HERA,
                label: i18nManager.Labels.common.continue,
                props: { raised: true, style: { padding: "13px 25px", marginBottom: 20 } },
            },
            onLoading: async (alert: AlertInterface) => {
                supportRequestService.createSupportTicket(payload).then(({ sanitized }: SanitizedResponse<any>) => {
                    Debugger.log("Create:submitRequest:loadingAlert:onLoading:success", sanitized);
                    ticketId = sanitized.external_id;
                    alert.doneLoading();
                }).catch((error: SanitizedResponse<any>) => {
                    Utils.reportError(error);
                    alert.hide();
                }).finally(() => {
                    submitButtonManageRef.current?.setLoadingState(false);
                });
                return false;
            },
            onConfirm: () => {
                alert.hide();
                navigate(`/${platform}/support/ticket/${ticketId}`);
            }
        });
        alert.show();
    }

}

export default Create;
